import { useEffect, useState } from 'react'
import {loading, Wrapped} from './wrapped'
import { Config } from '../types/config'
import {getConfig, LOADED} from './communication'

let configuration : Config

export function useInitConfig() : [Wrapped<Config>, () => void] {
    const [config, setConfig] = useState(loading<Config>(null!));
    const initConfigs = () => {
        getConfig().then(r => setConfig(r))
    }

    useEffect(() => {
        if (config.statusCode === LOADED) configuration = config.data!;
    }, [config]);

    return [config, initConfigs];
}

export function useConfig() {
    if (configuration === null) throw Error("Configuration used without initialization")
    return configuration;
}